<template>
    <SectionWrapper>
        <template #sticky>
            <EfficiencyFilters
                :is-efficiency-chart-open.sync="isEfficiencyChartOpen">
            </EfficiencyFilters>
        </template>

        <ExpandFullscreen
            v-if="isEfficiencyChartOpen"
            class="chart-modal"
            fixed-orientation
            :available-orientations="['landscape-primary']"
            start-orientation="landscape-primary">
            <EfficiencyChartFilters></EfficiencyChartFilters>
            <EfficiencyChart></EfficiencyChart>
        </ExpandFullscreen>
        <EfficiencyTable></EfficiencyTable>
    </SectionWrapper>
</template>

<script>
  import EfficiencyFilters from "@/components/Admin/Efficiency/EfficiencyFilters";
  import EfficiencyChartFilters from "./EfficiencyChart/EfficiencyChartFilters";
  import EfficiencyTable from "@/components/Admin/Efficiency/EfficiencyTable";
  import ExpandFullscreen from "@/components/Common/Chart/ExpandFullscreen";
  import EfficiencyChart from "./EfficiencyChart/EfficiencyChart";
  import SectionWrapper from "@/components/Common/SectionWrapper";
  import { mapActions } from "vuex";
  import { SET_EMPTY } from "@core/store/mutation-constants";

  export default {
    name: "Efficiency",
    components: {
      EfficiencyChartFilters,
      EfficiencyFilters,
      ExpandFullscreen,
      EfficiencyChart,
      EfficiencyTable,
      SectionWrapper
    },

    data () {
      return {
        isEfficiencyChartOpen: false
      };
    },

    methods: {
      ...mapActions("admin/efficiency", [SET_EMPTY])
    },

    beforeDestroy () {
      this.SET_EMPTY();
    }
  };
</script>

<style scoped>

</style>
